import { Box, IconButton, Stack } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { queryClient } from '../../App'
import { getImageSrc } from '../../helpers/getImageSrc'
import {
  checkReplacedEquipmentEverywhere,
  EQUIPMENT_KEYS,
} from '../../services/EquipmentApiService'
import { CheckReplacedEquipmentEverywhereRes } from '../../types/equipment.types'
import FormInput from '../../views/SingleRequestPage/components/SingleRequestDrawer/elements/FormInput'

interface ReplacedEquipmentCheckingFieldProps {
  equipmentId: string
  defaultEquipmentId: string
  lastCheckedId: string
  error: boolean
  control: any
  onReplacedChecked: (data?: CheckReplacedEquipmentEverywhereRes) => void
  withLabel?: boolean
  hideCheckBtn?: boolean
  disabled?: boolean
  checkDefault?: boolean
}

const ReplacedEquipmentCheckingField: FC<
  ReplacedEquipmentCheckingFieldProps
> = ({
  equipmentId,
  onReplacedChecked,
  lastCheckedId,
  defaultEquipmentId,
  error,
  control,
  withLabel,
  hideCheckBtn,
  disabled,
  checkDefault,
}) => {
  const onCheckEquipment = async () => {
    const data = await queryClient.fetchQuery({
      queryKey: [EQUIPMENT_KEYS.CHECK_EQUIPMENT_EVERYWHERE, equipmentId],
      queryFn: () =>
        checkReplacedEquipmentEverywhere({
          smartCardId: equipmentId,
        }),
      gcTime: 0,
    })

    onReplacedChecked(data)
  }

  const isEquipmentIdChecked = lastCheckedId === equipmentId
  const isSameId = equipmentId === defaultEquipmentId && !checkDefault

  const showCheckedBtn =
    !hideCheckBtn &&
    !isEquipmentIdChecked &&
    !error &&
    !!equipmentId &&
    !isSameId

  return (
    <Stack direction='row' alignItems={'center'} gap={'8px'}>
      <FormInput
        control={control}
        fullWidth
        name={'replacedEquipmentId'}
        label={withLabel ? 'ID нового оборудования' : ''}
        placeholder='Введите ID оборудования'
        onlyNumbers
        disabled={disabled}
      />
      {showCheckedBtn && (
        <IconButton sx={iconBtnSx} onClick={() => onCheckEquipment()}>
          <Box component={'img'} src={getImageSrc('check')} sx={checkSx} />
        </IconButton>
      )}
    </Stack>
  )
}

const iconBtnSx = {
  padding: '8px',
  background: 'rgba(217, 217, 217, 0.30)!important',
}
const checkSx = { height: '18px', width: '18px', opacity: '.8' }

export default observer(ReplacedEquipmentCheckingField)
